import { resourceTag } from '@krp/client-runtime'
import { createDuplicatesUiModule } from '@krp/duplicates-ui'
import {
  PLATFORM_RESOURCE_TAG,
  PLATFORM_SEARCH_TAG,
  createPlatformUiModule,
  resourcesApi,
  searchApi,
} from '@krp/platform-ui'
import { createAqsiUiModule } from '@krp/resource-aqsi-ui'
import { createOneCUiModule } from '@krp/resource-onec-ui'
import { createOwnUiModule } from '@krp/resource-own-ui'
import { createReceiptsUiModule } from '@krp/resource-receipts-ui'
import { createScheduleUiModule } from '@krp/schedule-ui'
import { createSyncUiModule } from '@krp/sync-ui'

/**
 * Подключение пакетов (G3): каждый пакет — одна строка, его внутренности
 * приложение не правит. Ключ модуля в RootState = `module.id` (проверяет тест
 * composition). Порты пакетов реализуются здесь — это единственное место,
 * где сценарий пакета связывается с инфраструктурой приложения.
 */
export const platformModule = createPlatformUiModule({
  resources: (dispatch) => ({
    reloadList: () => {
      dispatch(resourcesApi.util.invalidateTags([{ type: PLATFORM_RESOURCE_TAG, id: 'LIST' }]))
    },
    reloadResource: (resourceId) => {
      dispatch(resourcesApi.util.invalidateTags([resourceTag(PLATFORM_RESOURCE_TAG, resourceId, 'SUMMARY')]))
    },
  }),
  search: (dispatch) => ({
    reloadHealth: () => {
      dispatch(searchApi.util.invalidateTags([{ type: PLATFORM_SEARCH_TAG, id: 'HEALTH' }]))
    },
  }),
})

export const oneCModule = createOneCUiModule()
export const aqsiModule = createAqsiUiModule()
export const ownModule = createOwnUiModule()
export const receiptsModule = createReceiptsUiModule()
export const duplicatesModule = createDuplicatesUiModule()
export const syncModule = createSyncUiModule()
export const scheduleModule = createScheduleUiModule()

export const MODULES = [platformModule, oneCModule, aqsiModule, ownModule, receiptsModule, duplicatesModule, syncModule, scheduleModule] as const
